export type OverviewOrganizationOption = {
  id: string;
  name: string;
};

export type OverviewDepartmentOption = {
  id: string;
  name: string;
  organization_id: string;
};

export function departmentsForOrganization(
  departments: OverviewDepartmentOption[],
  organizationId: string | null,
): OverviewDepartmentOption[] {
  if (!organizationId) return [];
  return departments.filter((department) => department.organization_id === organizationId);
}
